(() => {
  const ROOT_SELECTOR = '[data-interactive-feature-showcase]';

  function setActive(root, index) {
    const modules = [...root.querySelectorAll('[data-feature-module]')];
    const images = [...root.querySelectorAll('[data-feature-image]')];

    modules.forEach((module) => {
      const active = module.dataset.featureModule === String(index);
      module.classList.toggle('is-active', active);
      module.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    images.forEach((image) => {
      const active = image.dataset.featureImage === String(index);
      image.classList.toggle('is-active', active);
      image.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }

  function init(root) {
    if (root.dataset.interactiveFeatureReady === 'true') return;
    root.dataset.interactiveFeatureReady = 'true';

    const modules = [...root.querySelectorAll('[data-feature-module]')];
    if (!modules.length) return;

    modules.forEach((module) => {
      const activate = () => setActive(root, module.dataset.featureModule);
      module.addEventListener('mouseenter', activate);
      module.addEventListener('focus', activate);
      module.addEventListener('click', activate);
      module.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate();
        }
      });
    });

    setActive(root, modules[0].dataset.featureModule);
  }

  function boot(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
